import React, {Component, ReactElement, ReactNode} from 'react'

import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import {NatGetAdminBulletinBoardThread} from './repository/NatGetAdminBulletinBoardThread'
import {
    CommentToFileImage,
    NatGetAdminBulletinBoardThreadComment,
    ResultData as CommentInfo,
} from './repository/NatGetAdminBulletinBoardThreadComment'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {BackLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {Messages} from '../../../Messages'
import {MESSAGE_TYPE, ROLE_TYPE, VIEW_DO_OR_NOT} from '../../../CodeMaster'
import styled from 'styled-components'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import {Box, Card, CardMedia, Link, Table, TableBody, TableCell, TableRow} from '@mui/material'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {getFileIconPath} from '../../common/util/Natutil'
import {
    NatPutBulletinBoardThreadComment,
    NatPutBulletinBoardThreadCommentParams,
} from './repository/NatPutBulletinBoardThreadComment'
import {isIE} from 'react-device-detect'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Location} from 'react-router-dom'


interface Props {
    threadId: number
    commentId: number
    bulletinBoardRepo: NatBulletinBoardRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    isLoadCompleted: boolean
    threadTitle: string
    threadContributorRoomNumber: string
    threadContributorName: string
    threadUserId: string
    threadRoleName: string
    commentInfo: CommentInfo
}

class NatAdminBulletinBoardThreadCommentPage extends Component<Props & AdminPagePropsSet, States> {


    constructor(props: Props & AdminPagePropsSet) {
        super(props)


        this.state = {
            isLoadCompleted: false,
            threadTitle: '',
            threadContributorRoomNumber: '',
            threadContributorName: '',
            threadUserId: '',
            threadRoleName: '',
            commentInfo: {
                threadId: 0,
                commentId: 0,
                comment: '',
                userId: '',
                roleName: '',
                contributorRidgeName: '',
                contributorRoomNumber: '',
                contributorFamilyName: '',
                contributorFirstName: '',
                invisible: '',
                commentToFileImage: [],
                commentToFileOther: [],
                version: 0,
            },
        }

        this.commentVisibilityControlCancel = this.commentVisibilityControlCancel.bind(this)
        this.commentVisibilityControlOk = this.commentVisibilityControlOk.bind(this)
        this.threadVisibilityControl = this.threadVisibilityControl.bind(this)
        this.backThreadPage = this.backThreadPage.bind(this)


    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {

            // スレッド取得(管理)
            const bulletinBoardThreadResponse: Nullable<NatGetAdminBulletinBoardThread> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.getAdminBulletinBoardThread.bind(
                        this.props.bulletinBoardRepo, this.props.threadId),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )
            if (bulletinBoardThreadResponse && bulletinBoardThreadResponse.details) {
                this.setState({
                    threadTitle: bulletinBoardThreadResponse.details.title,
                    threadContributorRoomNumber: bulletinBoardThreadResponse.details.contributorRidgeName
                        + ' ' + bulletinBoardThreadResponse.details.contributorRoomNumber,
                    threadContributorName: bulletinBoardThreadResponse.details.contributorFamilyName
                        + ' ' + bulletinBoardThreadResponse.details.contributorFirstName,
                    threadUserId: bulletinBoardThreadResponse.details.userId,
                    threadRoleName: bulletinBoardThreadResponse.details.roleName,
                })
            } else {
                return
            }

            // コメント取得（管理）
            const bulletinBoardThreadCommentResponse: Nullable<NatGetAdminBulletinBoardThreadComment> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.getAdminBulletinBoardThreadComment.bind(
                        this.props.bulletinBoardRepo, this.props.threadId, this.props.commentId),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )

            if (bulletinBoardThreadCommentResponse && bulletinBoardThreadCommentResponse.details) {
                this.setState({
                    commentInfo: bulletinBoardThreadCommentResponse.details,
                })
            } else {
                return
            }

            this.showInitialMessage()

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    // 表示する/表示しないリンク押下
    async threadVisibilityControl(): Promise<void> {
        this.beforeUserAction()
        if (!this.state.commentInfo) {
            return
        }
        let errorLevel: MESSAGE_TYPE
        let message: string = ''
        if (this.state.commentInfo.invisible === VIEW_DO_OR_NOT.HIDDEN.value) {
            // 表示する(現在、表示しない状態)
            errorLevel = Messages.IOPCA0007.errorLevel
            message = Messages.IOPCA0007.toString('コメント')
        } else {
            // 表示しない(現在、表示する状態)
            errorLevel = Messages.IOPCA0008.errorLevel
            message = Messages.IOPCA0008.toString('コメント')
        }
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: errorLevel,
                message: message,
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.commentVisibilityControlCancel,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.commentVisibilityControlOk,
                    },
                ],
            },
        )
    }

    commentVisibilityControlCancel(): void {
        this.props.eventEmitter.closeDialog()
    }

    async commentVisibilityControlOk(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        const putBulletinBoardThreadCommentParams: NatPutBulletinBoardThreadCommentParams = {
            invisible: this.state.commentInfo.invisible === VIEW_DO_OR_NOT.HIDDEN.value ?
                VIEW_DO_OR_NOT.DISPLAY.value : VIEW_DO_OR_NOT.HIDDEN.value,
            version: this.state.commentInfo.version,
        }

        try {
            const response: Nullable<NatPutBulletinBoardThreadComment> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.putBulletinBoardThreadComment.bind(
                        this.props.bulletinBoardRepo,
                        this.props.threadId,
                        this.props.commentId,
                        putBulletinBoardThreadCommentParams,
                    ),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0002.toString('コメント')},
                )
            if (response && response.requestError === null) {
                this.props.navigate(`/admin/bulletinBoardThread/${this.props.threadId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: this.state.commentInfo.invisible === VIEW_DO_OR_NOT.HIDDEN.value ?
                                    Messages.IOPCA0005.toString('コメント') :
                                    Messages.IOPCA0006.toString('コメント'),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    backThreadPage(): void {
        this.props.navigate(
            `/admin/bulletinBoardThread/${this.props.threadId}`,
        )
    }


    renderPageHeaderArea(): ReactElement {
        return (
            <>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_BOARD_MANAGEMENT}>
                    <PageFotterAreaRight>
                        <StyledLink
                            onClick={this.threadVisibilityControl}>
                            {(this.state.commentInfo &&
                            this.state.commentInfo.invisible === VIEW_DO_OR_NOT.HIDDEN.value ?
                                VIEW_DO_OR_NOT.DISPLAY.label : VIEW_DO_OR_NOT.HIDDEN.label)
                            }
                        </StyledLink>
                    </PageFotterAreaRight>
                </AuthorityChecker>
            </>
        )
    }

    renderImageCard(commentImages: CommentToFileImage[]): ReactElement {
        return (<>{
            commentImages.map((image, index) => {
                return (
                    <Box
                        ml={(index !== 0) ? '10px' : undefined}
                        key={index}
                    >
                        <Card>
                            <StyledCardContent>
                                <CardMedia
                                    style={{maxWidth: '200px', maxHeight: '200px'}}
                                    component={'img'}
                                    src={image.path}
                                />
                            </StyledCardContent>
                        </Card>
                    </Box>
                )
            })
        }</>)
    }

    renderPageBodyCommentInfoArea(): ReactElement {
        return (
            <>
                <Box marginTop={'10px'}>
                    <Table>
                        <StyledTableCaption>コメント情報</StyledTableCaption>
                        <TableBody>
                            <TableRow>
                                <TableRowName>スレッドタイトル</TableRowName>
                                <TableCell colSpan={3}>
                                    {this.state.threadTitle}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>スレッド投稿者:部屋番号</TableRowName>
                                <TableCell colSpan={3}>
                                    {(this.state.threadUserId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                                        '' : this.state.threadContributorRoomNumber
                                    }
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>スレッド投稿者</TableRowName>
                                <TableCell colSpan=
                                               {(this.state.threadUserId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                                                   2 : 3}>
                                    {`${this.state.threadContributorName}`}
                                </TableCell>
                                {(this.state.threadUserId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                                    <TableCell>
                                        {Messages.INTFA0028.toString(this.state.threadRoleName)}
                                    </TableCell>
                                    :
                                    <></>
                                }
                            </TableRow>
                            <TableRow>
                                <TableRowName>コメント内容</TableRowName>
                                <TableCellWordBreakAll colSpan={3}>
                                    <div dangerouslySetInnerHTML={{__html: this.state.commentInfo.comment}}/>
                                </TableCellWordBreakAll>
                            </TableRow>


                            <TableRow>
                                <TableRowName>コメント投稿者:部屋番号</TableRowName>
                                <TableCell colSpan={3}>
                                    {(this.state.commentInfo.userId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                                        '' : `${this.state.commentInfo.contributorRidgeName} ${this.state.commentInfo.contributorRoomNumber}`
                                    }
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>コメント投稿者</TableRowName>
                                <TableCell colSpan=
                                               {(this.state.commentInfo.userId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                                                   2 : 3}>
                                    {`${this.state.commentInfo.contributorFamilyName} ${this.state.commentInfo.contributorFirstName}`}
                                </TableCell>
                                {(this.state.commentInfo.userId.slice(0, 1) === ROLE_TYPE.ADMIN.value) ?
                                    <TableCell>
                                        {Messages.INTFA0028.toString(this.state.commentInfo.roleName)}
                                    </TableCell>
                                    :
                                    ''
                                }
                            </TableRow>
                            <TableRow>
                                <TableRowName>画像</TableRowName>
                                <TableCell colSpan={3}>
                                    <LeftRowFlexContainer>
                                        {this.renderImageCard(this.state.commentInfo.commentToFileImage)}
                                    </LeftRowFlexContainer>
                                </TableCell>
                            </TableRow>
                            {(this.state.commentInfo.commentToFileOther.length > 0) ?
                                this.state.commentInfo.commentToFileOther.map((commentFile, index) => (
                                    <TableRow key={`index_${index}`}>
                                        {index === 0 &&
                                            <TableRowName
                                                rowSpan={this.state.commentInfo.commentToFileOther.length}>
                                                ファイル
                                            </TableRowName>
                                        }

                                        <CommentFileIconCell>
                                            {this.getFileLink(
                                                commentFile.fileName, commentFile.path, commentFile.fileNameExtension)}
                                        </CommentFileIconCell>
                                        <TableCell>
                                            {commentFile.fileName}
                                        </TableCell>
                                        <TableCell>並び順 {commentFile.sortOrder}</TableCell>

                                    </TableRow>
                                )) :
                                <TableRow>
                                    <TableRowName>ファイル</TableRowName>
                                    <TableCell colSpan={3}></TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </Box>
            </>
        )
    }

    getFileLink(fileName: string, filePath: string, fileNameExtension: string): ReactElement {
        switch (fileNameExtension.toUpperCase()) {
            case 'PDF':
                if (isIE) {
                    return (
                        <LinkForIe onClick={() => window.open(filePath)}
                                   target={'_blank'}>
                            <img src={getFileIconPath(fileNameExtension)}
                                 alt=""/>
                        </LinkForIe>
                    )
                } else {
                    return (
                        <Link href={filePath} target={'_blank'} underline="hover">
                            <img src={getFileIconPath(fileNameExtension)}
                                 alt=""/>
                        </Link>
                    )
                }
                break
            default:
                return (
                    <Link href={filePath} download underline="hover">
                        <img src={getFileIconPath(fileNameExtension)}
                             alt=""/>
                    </Link>
                )
                break
        }
    }


    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backThreadPage}
                    >
                        スレッド詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageFooterArea>
                    {this.renderPageHeaderArea()}
                </PageFooterArea>
                <PageMainArea>
                    {this.renderPageBodyCommentInfoArea()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }

}

const CommentFileIconCell = styled(TableCell)`
  &.MuiTableCell-root {
    width: 100px;
  }
`

const LinkForIe = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
`

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`

const StyledCardContent = styled.div`
  background-color: #EEEEEE;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default createAdminPage(NatAdminBulletinBoardThreadCommentPage)

